import { render, staticRenderFns } from "./PendingRewards.vue?vue&type=template&id=bf9e408c&"
import script from "./PendingRewards.vue?vue&type=script&lang=js&"
export * from "./PendingRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PendingRewards.vue"
export default component.exports